import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/inductions/'
)({
  beforeLoad: () => {
    throw redirect({ to: '/organizations/settings/induction' })
  },
  component: () => null,
})
